module.exports = __webpack_public_path__ + "static/media/ellipsis-horizontal.1d2afc35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/svg/ellipsis-horizontal.svg
// module id = 1281
// module chunks = 0